<template>
  <div class="wrap container-fluid vertical-spacing">
    <div class="row">
      <div class="col-md-3 flexbox-desktop-only">
        <SfHeading class="sf-heading--left" :level="3" :title="myAccountTitle"/>
        <router-link
          v-for="link in myAccountLinks"
          :key="link.name"
          :to="link.path"
        >{{ $t(getRouteName(link)) }}</router-link>
      </div>
      <div class="col-xs-12 col-md-9">
        <router-view />
      </div>
    </div>
  </div>
</template>
<script>
import routes from '@/modules/core/mixins/routes';
import { SfHeading } from '@storefront-ui/vue';
import user from '../mixins/user';
import myAccountLinks from '../mixins/myAccountLinks';

export default {
  name: 'MyAccount',
  mixins: [user, routes, myAccountLinks],
  components: {
    SfHeading,
  },
  created() {
    this.fetchCustomer();
  },
  computed: {
    myAccountTitle() {
      return this.$t('My Account');
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/_helpers";
@import "src/scss/_breakpoint";

.sf-heading {
  margin-bottom: var(--spacer-base);
}

a {
  font: var(
    --menu-item-font,
    var(--menu-item-font-weight, var(--font-normal))
      var(--menu-item-font-size, var(--font-base)) /
      var(--menu-item-font-line-height, 1.4)
      var(--menu-item-font-family, var(--font-family-secondary))
  );
  display: block;
  margin-bottom: var(--spacer-xs);
  color: var(--_c-gray-secondary);
  text-decoration: none;
  &:hover {
    color: var(--c-dark);
  }
}
a.router-link-active {
  color: var(--c-dark);
}
</style>
